
import { server } from '../engine/server'
import { modal } from '../utilities/modal';

var PTIAccessControl = Class.create({
    accessControls: null,
  	initialize: function() {

	},
	getAccessControls: function(buildingId, callback) {
        var self = this;
		var url = "building/" + buildingId + '/accesscontrols/all';
		var data = server.getData(url,null, true);
		data
		.done(function(response){
            self.accessControls = response.data;
			callback(response);
		})
		.fail(function(e){
			console.log(e);
		});
    },
    sendCommand: function(command, deviceId, actionId, systemId, gateId, controlId, access_control_id, callback) {
		var url = "accesscontrol/command/send";
		var data = server.getData(url, {command: command, deviceId: deviceId, actionId: actionId, systemId: systemId, gateId: gateId, controlId: controlId, access_control_id: access_control_id} , true, 'POST');
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            modal.showInfo("Failed to send command!", "error", "top", "center");
		});
    },
    clearAll: function() {
        this.accessControls = null;
    }
});

export let ptiAccessControl = new PTIAccessControl();


// WEBPACK FOOTER //
// app/core/controllers/PTIAccessControl.js